module.exports = "../images/fishing-lodge-2-16.jpg?v=f386803";